<template>
	<div class="app-icon-container" :class="sizeClass">
		<img
				:src="iconSrc"
				:class="['app-icon', sizeClass]"
				:alt="name"
				@error="handleError"
		/>
<!--		<span v-if="hasError" class="app-icon-fallback-text">{{ props.name }}</span>-->
	</div>
</template>

<script setup>
import {computed, ref} from 'vue'

const props = defineProps({
	name: {type: String, required: true},
	size: {type: String, default: ''} // Empty string means fill container
})

const hasError = ref(false)
const sizeClass = computed(() => props.size ? `app-icon-${props.size}` : 'app-icon-fill')
const iconSrc = computed(() => {
	if(hasError.value) {
		return new URL('../assets/app_icons/default.webp', import.meta.url).href
	}
	return new URL(`../assets/app_icons/${props.name}`, import.meta.url).href
})

function handleError() {
	hasError.value = true
	console.warn(`App icon not found: ${props.name}`)
}
</script>

<style scoped>
.app-icon-container {
	display: inline-block;
	position: relative;
	vertical-align: middle;
}

.app-icon-fallback-text {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translatex(-50%);
	/*font-size: 10px;*/
	background: var(--color-surface-2);
	padding: var(--spacing-md);
	border-radius: var(--border-radius-sm);
	pointer-events: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
}

.app-icon {
	display: inline-block;
	vertical-align: middle;
	object-fit: contain;
}

.app-icon-fill {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

/* Size variants if needed elsewhere */
.app-icon-xs {
	width: 16px;
	height: 16px;
}

.app-icon-sm {
	width: 20px;
	height: 20px;
}

.app-icon-md {
	width: 24px;
	height: 24px;
}

.app-icon-lg {
	width: 32px;
	height: 32px;
}

.app-icon-xl {
	width: 48px;
	height: 48px;
}
</style>